<template>

    <div class="row">
        <q-card v-if="order" class="bg-white col-12 q-pa-md">

            <div class="row">
                <div class="col-6 q-pr-sm">
                    <q-field readonly borderless
                             label="Order Number"
                             class="full-width"
                             stack-label>
                        <template v-slot:control>
                            <div class="no-outline text-subtitle2">{{ order.orderID }}</div>
                        </template>
                    </q-field>

                    <q-field readonly borderless
                             label="Status"
                             class="full-width"
                             stack-label>
                        <template v-slot:control>
                            <div class="no-outline">
                                <q-badge transparent :color="getOrderStatusColor(order.status)">
                                    {{ getOrderStatus(order.status) }}
                                </q-badge>
                            </div>
                        </template>
                    </q-field>
                    <q-field readonly borderless
                             label="Currency"
                             class="full-width"
                             stack-label>
                        <template v-slot:control>
                            <div class="no-outline">{{ currencyText }}</div>
                        </template>
                    </q-field>
                </div>
                <div class="col-6">

                    <q-field readonly borderless
                             label="Order Date"
                             class="full-width"
                             stack-label>
                        <template v-slot:control>
                            <div class="no-outline">{{ order.orderDate | date }}</div>
                        </template>
                    </q-field>
                    <q-field readonly borderless
                             label="Customer"
                             class="full-width"
                             stack-label>
                        <template v-slot:control>
                            <div class="no-outline">{{ fullName }}</div>
                        </template>
                    </q-field>
                </div>
            </div>

        </q-card>
    </div>
</template>
<script>
    export default {
        name: 'order-details-info',
        props: {
            order: Object,
        },
        computed: {
            fullName() {
                return this.order.firstName + ' ' + this.order.lastName
            },
            currencyText() {
                return (this.order.currency == 0) ? 'USD' : "CAD"
            }
        },

    }
</script>
